import { DEFAULT_REGION_ID } from "@/components/Header/Info";
import client from './client';
import { IObjectResponse, IObjectListResponse } from '@/types/api-responses';

export async function object(id: number) {
    const { data } = await client.GET('/api/v1/public/pharmacies/{id}', {
        params: { path: { id } }
    });
    return data as unknown as IObjectResponse;
}

export async function getObjects(all_day: number, proizv: number, regionId: number = DEFAULT_REGION_ID) {
    const { data } = await client.GET('/api/v1/public/pharmacies', {
        params: { query: { allDay: all_day, proizv, region: regionId } }
    });
    const response = data as unknown as IObjectListResponse[];
    if (!Array.isArray(response)) return [];
    response.forEach(item => item.all_day = item.obj_all_day);
    return response;
}